import * as Tone from 'tone';
import { createSampleMapFromUrls, getNoteFromIndex, shuffleArray } from "../../functions";
export class GesturePlayer {
    constructor({ path, config, input }) {
        const { samples, volume, shuffle } = config;
        this.index = 0;
        this.samplesData = shuffle ? shuffleArray(samples) : samples;
        // Convert the sample names to urls
        let sampleUrls = this.samplesData.map(({ name }) => `${name}.mp3`);
        const sampleMap = createSampleMapFromUrls(sampleUrls);
        // Create a sampler
        this.sampler = new Tone.Sampler({
            baseUrl: `./audio/${path}/`,
            urls: sampleMap,
            attack: 1,
            release: 1,
            volume,
            curve: "linear",
        });
        if (input) {
            // console.log(`GesturePlayer connecting to input: ${input.toString()}`);
            this.sampler.connect(input);
        }
        else {
            // console.log("GesturePlayer connecting to context audio");
            this.sampler.toDestination();
        }
    }
    /**
     *  Play the next sample in the sequence
     * @param step
     */
    play(step) {
        // Allow direct selection otherwise step through
        const index = (step === undefined) ? this.index : step;
        const note = getNoteFromIndex(index);
        this.sampler.triggerAttackRelease(note, this.samplesData[index].duration || 4000);
        if (step === undefined) {
            this.index = (this.index + 1 + this.samplesData.length) % this.samplesData.length;
        }
    }
    // a function to stop a sample for a specific step
    stop(step) {
        // console.log(`Stopping sample ${step}`);
        const note = getNoteFromIndex(step);
        this.sampler.triggerRelease(note);
    }
    playSpecific(sampleName) {
        const index = this.samplesData.findIndex(({ name }) => name === sampleName);
        const note = getNoteFromIndex(index);
        this.sampler.triggerAttackRelease(note, this.samplesData[index].duration || 4000);
    }
    stopAll() {
        this.sampler.releaseAll();
    }
    cleanUp() {
        this.sampler.dispose();
    }
}
